import React from 'react';
import KeyFunction from '../KeyFunction';
import './MacroManagement.css';

const MacroManagement = () => <KeyFunction macroWorkspace />;

export default MacroManagement;
